import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  num: '01',
  text: 'Apply a few drops to the affected area'
}, {
  num: '02',
  text: 'Massage gently into the skin'
}, {
  num: '03',
  text: 'Feel warming relief within minutes'
}, {
  num: '04',
  text: 'Use daily or as needed'
}];
export function HowToUseSection() {
  return <section className="py-8 sm:py-12 bg-white" data-id="element-797">
      <div className="max-w-6xl mx-auto px-4" data-id="element-798">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 sm:gap-8" data-id="element-799">
          <div className="lg:col-span-1" data-id="element-800">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-light text-charcoal mb-3 sm:mb-4 tracking-tight" data-id="element-801">
              How To Use
            </h2>
            <p className="text-sm sm:text-base text-charcoal-light mb-6 font-light" data-id="element-802">
              No rituals. No waiting. Just relief that keeps pace with you.
            </p>
            <div className="h-full w-1 bg-bone hidden lg:block" data-id="element-803" />
          </div>

          <div className="lg:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6" data-id="element-804">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="relative pl-12 py-3" data-id="element-805">
                <span className="absolute left-0 top-0 text-4xl sm:text-5xl font-light text-bone-dark -z-10" data-id="element-806">
                  {step.num}
                </span>
                <div className="absolute left-0 top-6 w-8 h-1 bg-ginger" data-id="element-807" />
                <p className="text-sm sm:text-base font-light text-charcoal pt-2" data-id="element-808">
                  {step.text}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}